import { gql } from "@apollo/client";

export default gql`
  query getAssessmentDeliveriesReceived(
    $organizationId: Int!
    $targetId: Int
    $after: String
    $orderBy: String!
  ) {
    assessmentDeliveries(
      targetId: $targetId
      organizationId: $organizationId
      first: 10
      after: $after
      orderBy: $orderBy
      state_In: [delivered]
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          id
          deliveryDatetime
          lastSubmissionDatetime
          target {
            id
            name
            email
            firstName
            avatar
          }
          complianceProgram {
            id
            title
          }
        }
      }
    }
  }
`;
